import React, { useState } from 'react';

import BaseModal from '../BaseModal';
import ButtonTransparent from '../ui/ButtonTransparent';

import './index.css';

const UpdateCurrentCountModal = (props) => {
  console.log('UpdateCurrentCountModal props', props)

  const initState =
      {
      bin: props.bin.bin,
      partnum: props.bin.partnum,
      count: props.bin.currentCount
  }

  const [formValues, setFormValues] = useState(initState);


  const updateFields = (e) => {
    props.removeError();
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value.toUpperCase()
    });
  }

  const submit = (e) => {
    e.preventDefault();
    props.onUpdate(formValues);
  }

  const body = (
    <div className="bin-part-modal">
      <h2 className="bin-part-modal__title">Update Current Count</h2>
      <form className="bin-part-modal__form" onSubmit={submit} autoComplete="off">
        <div className="bin-part-modal__form-group">
          <label className="bin-part-modal__form-label" htmlFor="partnum">Part #</label>
          <input
            className="bin-part-modal__form-input"
            id="partnum"
            type="text"
            value={formValues.partnum}
            name="partnum"
            disabled={true}
          />
        </div>
        <div className="bin-part-modal__form-group">
          <label
            className="bin-part-modal__form-label"
            htmlFor="bin"
          >
            Bin #
          </label>
          <input
            className="bin-part-modal__form-input"
            id="bin"
            type="text"
            value={formValues.bin}
            name="bin"
            disabled={true}
          />
        </div>
        <div className="bin-part-modal__form-group">
          <label
            className="bin-part-modal__form-label"
            htmlFor="count"
          >
            Count
          </label>
          <input
            className="bin-part-modal__form-input"
            id="count"
            type="text"
            value={formValues.count}
            name="count"
            onChange={updateFields}
          />
        </div>
        <div className="bin-part-modal__form-error">
          {
            props.modalError &&
            <p className="bin-part-modal__error-text">{props.modalError}</p>
          }
        </div>
        <div className="bin-part-modal__form-group bin-part-modal__controls">
          <input 
            type="submit" 
            value="Update"
            className="bin-part-modal__form-submit btn btn--primary" 
            disabled={
              !Number.isInteger(+formValues.count)
              ||+formValues.count < 0 ||
              formValues.count === '' ||
              props.disabled ||
              props.modalError
            } 
          />
          <ButtonTransparent
            name="Cancel"
            className="job-details__form-submit btn btn--transparent"
            onClick={props.onClose}
          />
        </div>
      </form>
    </div>
  )
  return (
    <BaseModal 
      onClose={props.onClose}
      body={body}
    />
  ); 
}

export default UpdateCurrentCountModal;